module.exports = __webpack_public_path__ + "media/images/flags/kp-8ff7402b410311bd76287f24a27b1d34.svg";